import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { FirebaseError } from 'firebase/app';

import { AttractionsFirestoreResponse, AttractionType } from '../types';
import { fetchAttractions, fetchAttractionsByFilters } from './utils';

export const useGetAttractionsFromFirestore = (
  associationIds: string[],
  filterType?: AttractionType,
  options?: UseQueryOptions<AttractionsFirestoreResponse[], FirebaseError>,
): UseQueryResult<AttractionsFirestoreResponse[], FirebaseError> => useQuery<AttractionsFirestoreResponse[],
    FirebaseError>({
      queryKey: [filterType, associationIds] as const,
      queryFn: async (): Promise<AttractionsFirestoreResponse[]> => {
        // eslint-disable-next-line max-len
        const data = filterType ? await fetchAttractionsByFilters(associationIds, filterType) : await fetchAttractions(associationIds);

        return data.map((item) => ({
          id: item.id,
          thumbnail: item.thumbnail,
          cover_photo: item.cover_photo,
          title: item.title,
          type: item.type,
          localization: item.localization,
        }));
      },
      retry: 0,
      ...options,
    });
